import { dayjs } from "@outschool/time";

export function dayTickFormatter(tickItem: any) {
  const day = dayjs.utc(
    typeof tickItem === "number" ? dayjs.unix(tickItem) : tickItem
  );
  return day.format("MMM D YY");
}

export function percentFormatter(value: number) {
  return `${Math.round(value * 100)}%`;
}

export function numberFormatter(value: number, digits = 0) {
  return value.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function dollarFormatter(valueInCents: number, digits = 0) {
  return `${valueInCents < 0 ? "-" : ""}$${numberFormatter(
    Math.abs(valueInCents) / 100,
    digits
  )}`;
}

export function csvFormatter(valueInCents: number) {
  return dollarFormatter(valueInCents, 2);
}

export function dayTimeFormatter(dateString?: string) {
  return dateString && dayjs(dateString).format("MMM D YYYY, H:mm A");
}

export function dayFormatter(dateString?: string) {
  return dateString && dayjs(dateString).format("YYYY-MM-DD");
}

export function decimalFormatter(
  value: number,
  {
    minimumFractionDigits = undefined,
    maximumFractionDigits = undefined,
  }: {
    minimumFractionDigits?: number | undefined;
    maximumFractionDigits?: number | undefined;
  } = {}
) {
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);
}
